import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class I18nCommonService {
  constructor(private translocoService: TranslocoService) {}

  translate(key: string): string {
    return this.translocoService.translate(`common.${key}`);
  }
}
